export default function PHP_ftp_cdup() {
  return (
    <div>
      <h1>PHP_ftp_cdup</h1>
    </div>
  );
}
